
import { Component, Vue } from "vue-property-decorator";
import { PageMode } from "@/utils/type";
import {
    apiAppUpdateAdd,
    apiAppUpdateEdit,
    apiAppUpdateDetail,
} from "@/api/setting";

@Component
export default class AppUpdateEdit extends Vue {
    /** S Data **/
    mode: string = PageMode["ADD"];
    submitting: boolean = false;

    form: any = {
        sid: 0,
        platform: "android",
        client_type: "app",
        version_name: "",
        version_code: 0,
        min_version_code: 0,
        update_type: 1,
        package_url: "",
        apk_url: "",
        package_md5: "",
        package_size: 0,
        is_force: 0,
        is_silent: 0,
        status: 1,
        update_log: "",
    };

    rules: any = {
        platform: [{ required: true, message: "请选择平台", trigger: "change" }],
        client_type: [{ required: true, message: "请选择客户端类型", trigger: "change" }],
        version_name: [
            { required: true, message: "请填写对外版本号", trigger: "blur" },
            { max: 20, message: "最长 20 个字符", trigger: "blur" },
        ],
        version_code: [
            { required: true, message: "请填写内部版本号", trigger: "blur" },
            {
                validator: (_: any, value: any, cb: any) => {
                    if (value === undefined || value === null || value === "") {
                        cb(new Error("请填写内部版本号"));
                    } else if (Number(value) < 1) {
                        cb(new Error("内部版本号必须大于 0"));
                    } else {
                        cb();
                    }
                },
                trigger: "blur",
            },
        ],
        update_type: [{ required: true, message: "请选择更新类型", trigger: "change" }],
        package_url: [
            { required: true, message: "请填写更新包 URL", trigger: "blur" },
            { type: "url", message: "URL 格式不正确", trigger: "blur" },
        ],
    };
    /** E Data **/

    /** S Methods **/
    onSubmit(formName: string) {
        const refs: any = this.$refs[formName];
        refs.validate((valid: boolean) => {
            if (!valid) return;
            this.submitting = true;
            const action =
                this.mode === PageMode["ADD"]
                    ? apiAppUpdateAdd(this.form)
                    : apiAppUpdateEdit(this.form);
            action
                .then(() => {
                    setTimeout(() => this.$router.go(-1), 400);
                })
                .finally(() => {
                    this.submitting = false;
                });
        });
    }

    async initFormData(id: number) {
        const res: any = await apiAppUpdateDetail({ id });
        if (!res) return;
        Object.keys(res).forEach((key) => {
            this.$set(this.form, key, res[key]);
        });
    }
    /** E Methods **/

    /** S Life Cycle **/
    created() {
        const query: any = this.$route.query;
        if (query.mode) this.mode = query.mode;

        if (this.mode === PageMode["EDIT"] && query.id) {
            this.form.id = Number(query.id);
            this.initFormData(this.form.id);
        }
    }
    /** E Life Cycle **/
}
